import { render, staticRenderFns } from "./TotalLists.vue?vue&type=template&id=07ba9b94&scoped=true"
import script from "./TotalLists.vue?vue&type=script&lang=js"
export * from "./TotalLists.vue?vue&type=script&lang=js"
import style0 from "./TotalLists.vue?vue&type=style&index=0&id=07ba9b94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ba9b94",
  null
  
)

export default component.exports